import { authSagaWatcher } from './saga';

export const authModuleSaga = [authSagaWatcher];
